import {layoutMarkup} from "../layout/layoutMarkup.js";
import {componentsHelper} from "../../helpers/componentsHelper.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {imageTextDefaultContent} from './imageTextSectionDefaultContent';
import l10n from "../../../lang/locallang";

const imageTextSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(imageTextDefaultContent);
    const { content } = l10n.imageText;
    const { imageCaption } = l10n.editor;
    let text  = param.content && param.content.text ? param.content.text : content;
    let img_url = param.content && param.content.image_url ? param.content.image_url : '../../images/editor/CG_560853044.jpeg';
    let image_caption = param.content && param.content.image_caption ? param.content.image_caption : '';
    let image_caption_style = param.content && param.content.image_caption_style ? '' : 'display: none;';
    let image_alt = param.content && param.content.image_alt ? param.content.image_alt : '';
    let asset_id = param.content && param.content.asset_id ? param.content.asset_id : componentsHelper.setAssetUniqueID(null, 1, param.id, 'image');
    let image_width = param.content && param.content.image_width ? param.content.image_width : '50%';
    let imageClass;
    param.layout = param['@layout'] ? param['@layout'] : 'imageRightTextLeft';

    switch(param.layout) {
        case 'imageRightTextLeft':
            imageClass = 'editor-section section-image-with-text is-image-right';
            break;
        case 'imageLeftTextRight':
            imageClass = 'editor-section section-image-with-text is-image-left';
            break;
        case 'imageTextFullWidth':
            imageClass = 'editor-section section-image-with-text is-image-full-width';
            break;
        default:
            imageClass = 'editor-section section-image-with-text';
            break;
    }

    param.class = param.class ? param.class : imageClass;
    param.style = param.style ? param.style : '';
    param.section = 'imageTextSection';
    param.component = `
    <div class="image-near-text container-width" data-image-width="${image_width}">
        <div class="img-box">
            <figure class="image-container_figure">
                <img src="${img_url}" alt="${image_alt}" data-asset-id="${asset_id}">
                <figcaption class="image-container_caption" ${!is_public ? `placeholder="${imageCaption}" contenteditable="true"` : ''}>${image_caption}</figcaption>
            </figure>
        </div>
        <div class="text-box">
        ${!is_public ? `
            <div class="fr-editor-paragraph">
                ${text}
            </div>
        ` : `
            ${text}
        `}
        </div>
    </div>`;

    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {imageTextSection};
